import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TopNavigationService } from 'src/app/shared/navigation/top-navbar/top-nav.service';
import { role } from '../../shared/constants/role-enum';
import { Observable } from 'rxjs';
import { ImpersonationService } from '../../shared/impersonation/impersonation.service';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { UserDataService } from '../services/user-data.service';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/shared/common/common-service';

@Injectable()
export class ClientManagerAuthGaurd {
  pathWithNoMidMenu: Array<string> =
    ['/home', '/admin/user', '/admin/admin-client-user', '/admin/master-activities', '/admin/action-logs', '/surveys/survey-list', '/surveys/respondent-survey', '/surveys/client-sme'];

  constructor(
    private engService: CommonService,
    public topNavigationService: TopNavigationService,
    private impersonationService: ImpersonationService,
    private userDataService: UserDataService,
  ) { }
  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.checkCMRoute(childRoute, state);
  }

  checkCMRoute(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.userDataService.userDetails$.pipe(
      filter(({ roleId }) => {
        return roleId !== role.none
      }),
      switchMap(({ roleId }) =>
        this.impersonationService.clientManagerModeActive$.pipe(
          take(1),
          map(mode => {
            if (!mode && roleId === role.clientManager && route.params['studyId'] && Number(route.params['studyId']) > 0) {
              const studyId = route.params['studyId'];
              const cmSurveysUrl = `${environment.rcnSurveyUrl}client-manager/study/${studyId}/surveys`;
              location.assign(cmSurveysUrl);
              return false;
            } else {
              return true;
            }
          })
        )
      )
    );
  }

  private setRcnSurveyApplication(roleIds: number[]) {
    this.topNavigationService.setStudyNav(false);
    if (!roleIds?.includes(role.respondent)) {
      this.topNavigationService.setStudyNavRight(false);
      this.topNavigationService.setShowFeedback(false);
      return false;
    }
  }

  private setRcnApplication(state: RouterStateSnapshot, roleId: role) {
    if (!this.pathWithNoMidMenu.includes(state.url) && !state.url.toString().endsWith('smeview')) {
      // this.topNavigationService.setStudyNav(true);
    } else {
      this.topNavigationService.setStudyNav(false);
    }


    // this.impersonationService.clientManagerModeActive$.pipe(
    //   take(1),
    // ).subscribe((isClientMangerViewActive) => {
    //   if (isClientMangerViewActive) {
    //     this.topNavigationService.setIsClientManager(true);
    //   } else {
    //     this.topNavigationService.setIsClientManager(roleId === role.clientManager);
    //     if (state.url.includes(ROUTE_URL.STUDIES)) {
    //       this.topNavigationService.setIsClientUser(true);
    //     } else {
    //       this.topNavigationService.setIsClientUser(roleId === role.respondent);
    //     }
    //     this.topNavigationService.setIsClientAdmin(roleId === role.clientAdmin);
    //   }
    // })
  }
}
